import type { OfferVersion } from '@ooh/contracts';

export function isClientActedVersion(version: OfferVersion): boolean {
  return version.status === 'ACCEPTED' || version.rejectedAt != null;
}

/** Accepted first, then most recently acted-on, then latest published. */
export function pickDefaultVersionId(versions: OfferVersion[]): number | null {
  const accepted = versions.find((version) => version.status === 'ACCEPTED');
  if (accepted) return accepted.id;

  const clientActed = versions.filter(isClientActedVersion);
  const mostRecentActed = clientActed[clientActed.length - 1];
  if (mostRecentActed) return mostRecentActed.id;

  return versions[versions.length - 1]?.id ?? null;
}
